module.exports = __webpack_public_path__ + "static/media/Krombacher-SansRegularItalic.13835abd.woff2";